module.exports = "https://static-frontbase.operabase.net/cb1b2179-7711-4a34-921d-c4deab5611f7/_next/static/images/bitmap-629d21b2a0fc6f254c69ea637037f10b.jpg";